module.exports = __webpack_public_path__ + "static/stripe_accounts-9ed839431dd918ea7c19439e2ad69c15.png";